import React from 'react';
import { paymentOptions } from '../constants';
import swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(swal);

export const showTicketsInfoModal = (paymentTypes) => {
    MySwal.fire({
      html: (
        <>
          <h4 className="tickets-info-modal__title">
            Tickets info
          </h4>
          <ul className="tickets-info-modal__info-list">
            {paymentOptions.map(pt => {
              return (
                <li className="tickets-info-modal__info-item" key={pt.value}>
                  <span>{pt.label}:</span>
                  {paymentTypes[pt.value] || 0}
                </li>
              )
            })}
          </ul>
        </>
      ),
      width: "400px",
    })
};
